import { motion, useReducedMotion } from 'framer-motion';
import { Sparkle } from '@phosphor-icons/react';
import { useRutaAi } from '@/contexts/RutaAiContext';
import { ASK_ARIA_LABEL } from '@/lib/assistantFraming';
import { ASSISTANT_BRAND } from '@/components/ai-elements/assistant-brand';
import { PopoverAnchor } from '@/components/ui/popover';

// Glowing sparkle in the top-right header — the Ask door into Ruta AI (RUT-3902).
// Acts as the PopoverAnchor so the chat opens mounted under this icon; when the
// user detaches, the free-floating panel takes over and this just toggles closed.
//
// Glow/scale animate the *icon*, never the anchor button: Floating UI measures
// this node for popover position, and transform/filter on the anchor itself
// can re-measure as a 1px diagonal wobble while the panel is open.
export function RutaAiTrigger() {
  const reduce = useReducedMotion();
  const { open, openAi, closeAi } = useRutaAi();

  const label = open ? 'Close' : ASK_ARIA_LABEL;

  return (
    <PopoverAnchor asChild>
      <button
        type="button"
        onClick={() => {
          if (open) closeAi();
          else openAi(undefined, { framing: 'ask' });
        }}
        aria-label={label}
        title={label}
        aria-expanded={open}
        className="inline-flex h-9 w-9 items-center justify-center rounded-md text-[#cdeccd] hover:bg-white/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
      >
        <motion.span
          className="inline-flex"
          animate={
            reduce || open
              ? undefined
              : {
                  filter: [
                    `drop-shadow(0 0 3px ${ASSISTANT_BRAND.glow(0.5)})`,
                    `drop-shadow(0 0 11px ${ASSISTANT_BRAND.glow(1)})`,
                    `drop-shadow(0 0 3px ${ASSISTANT_BRAND.glow(0.5)})`,
                  ],
                }
          }
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
          whileHover={reduce || open ? undefined : { scale: 1.08 }}
          whileTap={reduce || open ? undefined : { scale: 0.94 }}
        >
          <Sparkle className="h-[18px] w-[18px]" strokeWidth={2} />
        </motion.span>
      </button>
    </PopoverAnchor>
  );
}
